import { useMicroNavigator } from "../../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import { usePoles } from "../../../hooks";
import PoleListView from "./PoleListView/PoleListView";
import { useCapability } from "../../../../rbac";



export default function PoleListPresenter() {
  const {getAllPole: {data, isLoading}, detelePoleToPlanBT} = usePoles();
  const {navigate} =useMicroNavigator()
  const canEdit = useCapability('planbt.edit')

  const onClick = (poleId: string) => {
    navigate("single", {poleId})
  }

  const handleDelete = (poleId: string) => {
    detelePoleToPlanBT.mutate({idPole: poleId})
  }

  const handleGoEdit = (poleId: string) => {
    navigate("edit", {poleId})
  }

  return (
    <PoleListView  handleDelete = {canEdit ? handleDelete : undefined} onPoleClick={(id) => onClick(id)}poleList={data?.data} isLoading={isLoading} handleEdit={canEdit ? handleGoEdit : undefined} />
  )
}
